/* */ 
(function(process) {
  'use strict';
  var global = require('global');
  var Promise = global.Promise || require('es6-promise').Promise;
  module.exports = function createAlgoliasearch(AlgoliaSearch, uaSuffix) {
    var inherits = require('inherits');
    var errors = require('../errors');
    var inlineHeaders = require('./inline-headers');
    var jsonpRequest = require('./jsonp-request');
    var places = require('../places');
    uaSuffix = uaSuffix || '';
    if (process.env.NODE_ENV === 'debug') {
      require('debug').enable('algoliasearch*');
    }
    function algoliasearch(applicationID, apiKey, opts) {
      var cloneDeep = require('../clone');
      var getDocumentProtocol = require('./get-document-protocol');
      opts = cloneDeep(opts || {});
      if (opts.protocol === undefined) {
        opts.protocol = getDocumentProtocol();
      }
      opts._ua = opts._ua || algoliasearch.ua;
      return new AlgoliaSearchBrowser(applicationID, apiKey, opts);
    }
    algoliasearch.version = require('../version');
    algoliasearch.ua = 'Algolia for vanilla JavaScript ' + uaSuffix + algoliasearch.version;
    algoliasearch.initPlaces = places(algoliasearch);
    global.__algolia = {
      debug: require('debug'),
      algoliasearch: algoliasearch
    };
    var support = {
      hasXMLHttpRequest: 'XMLHttpRequest' in global,
      hasXDomainRequest: 'XDomainRequest' in global
    };
    if (support.hasXMLHttpRequest) {
      support.cors = 'withCredentials' in new XMLHttpRequest();
    }
    function AlgoliaSearchBrowser() {
      AlgoliaSearch.apply(this, arguments);
    }
    inherits(AlgoliaSearchBrowser, AlgoliaSearch);
    AlgoliaSearchBrowser.prototype._request = function request(url, opts) {
      return new Promise(function wrapRequest(resolve, reject) {
        if (!support.cors && !support.hasXDomainRequest) {
          reject(new errors.Network('CORS not supported'));
          return;
        }
        url = inlineHeaders(url, opts.headers);
        var body = opts.body;
        var req = support.cors ? new XMLHttpRequest() : new XDomainRequest();
        var reqTimeout;
        var timedOut;
        var connected = false;
        reqTimeout = setTimeout(onTimeout, opts.timeouts.connect);
        req.onprogress = onProgress;
        if ('onreadystatechange' in req)
          req.onreadystatechange = onReadyStateChange;
        req.onload = onLoad;
        req.onerror = onError;
        if (req instanceof XMLHttpRequest) {
          req.open(opts.method, url, true);
        } else {
          req.open(opts.method, url);
        }
        if (support.cors) {
          if (body) {
            if (opts.method === 'POST') {
              req.setRequestHeader('content-type', 'application/x-www-form-urlencoded');
            } else {
              req.setRequestHeader('content-type', 'application/json');
            }
          }
          req.setRequestHeader('accept', 'application/json');
        }
        req.send(body);
        function onLoad() {
          if (timedOut) {
            return;
          }
          clearTimeout(reqTimeout);
          var out;
          try {
            out = {
              body: JSON.parse(req.responseText),
              responseText: req.responseText,
              statusCode: req.status,
              headers: req.getAllResponseHeaders && req.getAllResponseHeaders() || {}
            };
          } catch (e) {
            out = new errors.UnparsableJSON({more: req.responseText});
          }
          if (out instanceof errors.UnparsableJSON) {
            reject(out);
          } else {
            resolve(out);
          }
        }
        function onError(event) {
          if (timedOut) {
            return;
          }
          clearTimeout(reqTimeout);
          reject(new errors.Network({more: event}));
        }
        function onTimeout() {
          timedOut = true;
          req.abort();
          reject(new errors.RequestTimeout());
        }
        function onConnect() {
          connected = true;
          clearTimeout(reqTimeout);
          reqTimeout = setTimeout(onTimeout, opts.timeouts.complete);
        }
        function onProgress() {
          if (!connected)
            onConnect();
        }
        function onReadyStateChange() {
          if (!connected && req.readyState > 1)
            onConnect();
        }
      });
    };
    AlgoliaSearchBrowser.prototype._request.fallback = function requestFallback(url, opts) {
      url = inlineHeaders(url, opts.headers);
      return new Promise(function wrapJsonpRequest(resolve, reject) {
        jsonpRequest(url, opts, function jsonpRequestDone(err, content) {
          if (err) {
            reject(err);
            return;
          }
          resolve(content);
        });
      });
    };
    AlgoliaSearchBrowser.prototype._promise = {
      reject: function rejectPromise(val) {
        return Promise.reject(val);
      },
      resolve: function resolvePromise(val) {
        return Promise.resolve(val);
      },
      delay: function delayPromise(ms) {
        return new Promise(function resolveOnTimeout(resolve) {
          setTimeout(resolve, ms);
        });
      }
    };
    return algoliasearch;
  };
})(require('process'));
